import React, { useState } from 'react';
import { Form, Button, Alert,Nav } from 'react-bootstrap';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import Swal from 'sweetalert2';

// Base API URL from environment variable
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const UploadCourses = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState('');

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!selectedFile) {
      setMessage('Please select a CSV file to upload');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await axios.post(`${API_BASE_URL}/courses/upload_courses.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      });
      console.log("response: ". response.data);
      if (response.data.message) {
        Swal.fire({ icon: 'info', text: response.data.message });
      }
      setMessage(response.data.message);
    } catch (error) {
      console.error('Error uploading file:', error);
      setMessage('An error occurred while uploading the file.');
    }
  };

  return (
    <div>
      <h2>Upload Courses from CSV</h2>
      {message && <Alert variant="info">{message}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formFile">
          <Form.Label>Choose CSV File</Form.Label>
          <Form.Control type="file" accept=".csv" onChange={handleFileChange} />
        </Form.Group>
        <div className='mt-2'>
          <p>Download <a href={`${BASE_URL}/assets/list_of_courses.csv`}>CSV File template</a> for the courses list</p>
        </div>
        <Button variant="primary" type="submit" className='mt-2'>
          Upload
        </Button>
      </Form>
    </div>
  );
};

export default UploadCourses;
